import {useIntegrator} from "../integrator.context";
import {CSSProperties} from "react";

interface CheckmarkProps {
    id: string;
    style?: CSSProperties;
}

function Checkmark(props: CheckmarkProps) {
    const {state} = useIntegrator();

    const active = getActiveState();

    function getActiveState(): boolean {
        return (state.units?.find(u => u.id === props.id)?.active ?? false) ||
            (state.buildings?.find(u => u.id === props.id)?.active ?? false) ||
            (state.resources?.find(u => u.id === props.id)?.active ?? false) ||
            (state.tiles?.find(u => u.id === props.id)?.active ?? false) ||
            (state.unitAttributes?.find(u => u.uid === props.id || u.id === props.id)?.active ?? false) ||
            (state.buildingAttributes?.find(u => u.uid === props.id || u.id === props.id)?.active ?? false) ||
            (state.techActionAttributes?.find(u => u.uid === props.id || u.id === props.id)?.active ?? false) ||
            (state.techPassiveAttributes?.find(u => u.uid === props.id || u.id === props.id)?.active ?? false) ||
            (state.rewards?.find(u => u.uid === props.id || u.id === props.id)?.active ?? false);
    }

    return (
        <>
            {active && <span className={'fa-solid fa-check-circle'} style={{...{color: "#00b262", fontSize: 13}, ...props.style}}/>}
            {!active && <span className={'fa-solid fa-circle-x'} style={{...{color: "#d03700", fontSize: 13}, ...props.style}}/>}
        </>
    )
}

export default Checkmark;